import { render, staticRenderFns } from "./EmployeePropertyRolesList.vue?vue&type=template&id=edcbe7d2&"
import script from "./EmployeePropertyRolesList.vue?vue&type=script&lang=js&"
export * from "./EmployeePropertyRolesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip}, component.options.components || {})
